import './gb-product-image.tag.html';
import './gb-product-info.tag.html';
import './gb-variant-switcher.tag.html';
import { Product } from './gb-product';
riot.tag2('gb-product', '<yield> <gb-product-image></gb-product-image> <gb-product-info></gb-product-info> <gb-variant-switcher></gb-variant-switcher> </yield>', '', '', function(opts) {
    this._mixin(Product);
});



/** WEBPACK FOOTER **
 ** ./src/tags/product/gb-product.tag.html
 **/